const warningColors = {
  WARNING_50: '#fff8e4',
  WARNING_100: '#ffedba',
  WARNING_200: '#ffe18f',
  WARNING_300: '#ffd766',
  WARNING_400: '#FFCD4C',
  WARNING_500: '#fec442',
  WARNING_600: '#fdb73d',
  WARNING_700: '#fba539',
  WARNING_800: '#f99636',
  WARNING_900: '#f7792e',
}

export default warningColors
